import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { BlogServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Organisation States Master section
 */
const useListBlog = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["blog-list", page_no], BlogServices.blogList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddBlog = (onSuccess, onError = onDefaultError) => {
  return useMutation(BlogServices.addBlog, {
    onSuccess,
    onError,
  });
};
const useUpdateBlog = (onSuccess, onError = onDefaultError) => {
  return useMutation(BlogServices.updateBlog, {
    onSuccess,
    onError,
  });
};
const useViewBlog = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("blog-view", () => BlogServices.viewBlog({ id }), {
    onSuccess,
    onError,
  });
};
const useBlogDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(BlogServices.deleteBlog, {
    onSuccess,
    onError,
  });
};
export { useListBlog, useAddBlog, useUpdateBlog, useViewBlog, useBlogDelete };
